import { ElementType } from "../../../dom-tools/ElementType";
import { UIComponent } from "../../../dom-ui/components/UIComponent"

export class Arranger extends UIComponent
{
  static readonly elementType = new ElementType( "composer-arranger" );

  constructor()
  {
    super();

    this._setElement( Arranger.elementType.create() );
  }
}